import './Footer.css';
import logo from '../images/Nora img updated.png';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer  className="footer-two">
      <div  className="container">
        <div className="footer-row">
          {/* 1. Logo Section */}
          <div className="footer-column">
            <div className="footer-widget">
              <div className="footer-logo">
                <a href="https://www.nora.org.af/" target="_blank" rel="noopener noreferrer"> 
                  <img 
                    src={logo}
                    alt="NORA Organization Logo"
                  /> 
                </a>
              </div>
              <div className="footer-content">
                <p className="mission-text">
                  <a
                                  href="/admin"
                                  target="_blank" 
                                  rel="noopener noreferrer"
                                  className="admin-link"
                              > NORA: The Gateway to Prosperity, Health, and Education</a>
                </p>
                <p className="mission-text">Empowering Communities Through innovation & technologies</p>
              </div>

              {/* Social Media */}
              <div className="social-section">
                <h6>Follow Us</h6>
                <div className="social-icons">
                  <a 
                    href="https://www.facebook.com/share/1AAkJARfvf/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link facebook"
                    aria-label="Follow us on Facebook"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a 
                    href="https://x.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link x-social"
                    aria-label="Follow us on X"
                  >
                    <i className="fab fa-x-twitter"></i>
                  </a>
                    
                  <a 
                    href="https://www.linkedin.com/company/nedaya/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link linkedin"
                    aria-label="Follow us on LinkedIn"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                  <a 
                    href="https://wa.me/+93730405003"
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="social-link whatsapp"
                    aria-label="Contact us on WhatsApp"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                  
                </div>
              </div>
            </div>
          </div>
          
          {/* 2. Quick Links */}
          <div className="footer-column">
            <div className="footer-widget">
              <div className="footer-intro">
                <h5>Quick Links</h5>
                <div className="footer-line"></div>
                <ul className="footer-menu">
                  <li className="menu-item">
                    <Link to="/about">Who We Are</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/what-we-do">What We Do</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/where-we-work">Where We Work</Link>
                  </li>
            
                  <li className="menu-item">
                    <Link to="/#events-section">News & Events</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/">Completed Projects</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* 3. Main Activities */}
          <div className="footer-column">
            <div className="footer-widget">
              <div className="footer-intro">
                <h5>Main Activities</h5>
                <div className="footer-line"></div>
                <ul className="footer-menu">
                  <li className="menu-item">
                    <Link to="/education">Quality Education</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/health">Enhance Health Services</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/women">Empower Women and Children</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/freelancing">AI & Digital Skills Opportunities</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* 4. Get In Touch with Social Media */}
          <div className="footer-column">
            <div className="footer-widget">
              <div className="footer-intro">
                <h5>Get In Touch</h5>
                <div className="footer-line"></div>
              </div>
              <div className="footer-contact">
                <ul>
                  <li>
                    <i className="fas fa-map-marker-alt"></i>
                    <span>Kabul, Dehbori, Karwan University Street</span>
                  </li>
                  <li>
                    <i className="far fa-envelope"></i>
                    <a href="mailto:info@nora.org.af">info@nora.org.af</a>
                  </li>
                  <li>
                    <i className="fas fa-phone-alt"></i>
                    <a href="tel:+93202500200">0093 (0) 202500200</a>
                  </li>
                  <li>
                    <i className="fab  fa-whatsapp"></i>
                    <a href="tel:+93202500200">0093 (0) 730405003</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Copyright Section */}
      <div className="footer-copyright">
        <div className="container">
          <div className="copyright-row">
            <div className="copyright-text">
              <p>© 2025 NORA All Rights Reserved. Designed by <a href="https://toptargetsoft.com/" target="_blank" rel="noopener noreferrer">Hadafe Barter Technology Services Company</a></p>
            </div>
            <div className="copyright-links">
              <Link to="/terms">Terms & Conditions</Link>
              <Link to="/privacy">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

































// import './Footer.css';
// import logo from '../images/Nora img updated.png';
// import { Link } from 'react-router-dom';

// const Footer = () => {
//   return (
//     <footer  className="footer-two">
//       <div  className="container">
//         <div className="footer-row">
//           {/* 1. Logo Section */}
//           <div className="footer-column">
//             <div className="footer-widget">
//               <div className="footer-logo">
//                 <a href="https://www.nora.org.af/" target="_blank" rel="noopener noreferrer">
//                   <img 
//                     src={logo}
//                     alt="NORA Organization Logo"
//                   />
//                 </a>
//               </div>
//               <div className="footer-content">
//                 <p className="mission-text">
//                   NORA: The Gateway to Prosperity, Health, and Education
//                 </p>
//               </div>

//               {/* Social Media */}
//               <div className="social-section">
//                 <h6>Follow Us</h6>
//                 <div className="social-icons">
//                   <a 
//                     href="https://www.facebook.com/share/1AAkJARfvf/" 
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                     className="social-link facebook"
//                     aria-label="Follow us on Facebook"
//                   >
//                     <i className="fab fa-facebook-f"></i>
//                   </a>
//                   <a 
//                     href="https://x.com/" 
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                     className="social-link x-social"
//                     aria-label="Follow us on X"
//                   >
//                     <i className="fab fa-x-twitter"></i>
//                   </a>
                    
//                   <a 
//                     href="https://www.linkedin.com/company/nedaya/" 
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                     className="social-link linkedin"
//                     aria-label="Follow us on LinkedIn"
//                   >
//                     <i className="fab fa-linkedin-in"></i>
//                   </a>
//                   <a 
//                     href="https://wa.me/+93799010459" 
//                     target="_blank" 
//                     rel="noopener noreferrer"
//                     className="social-link whatsapp"
//                     aria-label="Contact us on WhatsApp"
//                   >
//                     <i className="fab fa-whatsapp"></i>
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           {/* 2. Quick Links */}
//           <div className="footer-column">
//             <div className="footer-widget">
//               <div className="footer-intro">
//                 <h5>Quick Links</h5>
//                 <div className="footer-line"></div>
//                 <ul className="footer-menu">
//                   <li className="menu-item">
//                     <Link to="/">Completed Projects</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/OnGoingProject">Ongoing Projects</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/where-we-work">Where We Work</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/about">Who We Are</Link>
//                   </li>
                  
                   
//                     <li className="menu-item">
//                       {/* Navigate to Home page and scroll to the events-section ID */}
//                       <Link to="/#events-section">Events</Link>
//                     </li>
                  
//                 </ul>
//               </div>
//             </div>
//           </div>
          
//           {/* 3. Main Activities */}
//           <div className="footer-column">
//             <div className="footer-widget">
//               <div className="footer-intro">
//                 <h5>Main Activities</h5>
//                 <div className="footer-line"></div>
//                 <ul className="footer-menu">
//                   <li className="menu-item">
//                     <Link to="/education">Quality Education</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/health">Enhance Health Services</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/women">Empower Women and Children</Link>
//                   </li>
//                   <li className="menu-item">
//                     <Link to="/freelancing">Freelancing Opportunities</Link>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
          
//           {/* 4. Get In Touch with Social Media */}
//           <div className="footer-column">
//             <div className="footer-widget">
//               <div className="footer-intro">
//                 <h5>Get In Touch</h5>
//                 <div className="footer-line"></div>
//               </div>
//               <div className="footer-contact">
//                 <ul>
//                   <li>
//                     <i className="fas fa-map-marker-alt"></i>
//                     <span>Kabul, Dehbori, Karwan University Street</span>
//                   </li>
//                   <li>
//                     <i className="far fa-envelope"></i>
//                     <a href="mailto:info@nora.org.af">info@nora.org.af</a>
//                   </li>
//                   <li>
//                     <i className="fas fa-phone-alt"></i>
//                     <a href="tel:+93799010459">0093 (0) 799010459</a>
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
      
//       {/* Copyright Section */}
//       <div className="footer-copyright">
//         <div className="container">
//           <div className="copyright-row">
//             <div className="copyright-text">
//               <p>© 2025 NORA All Rights Reserved. Designed by <a href="https://toptargetsoft.com/" target="_blank" rel="noopener noreferrer">Hadafe Barter Technology Services Company</a></p>
//             </div>
//             <div className="copyright-links">
//               <Link to="/terms">Terms & Conditions</Link>
//               <Link to="/privacy">Privacy Policy</Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;